/* Keep the original product controls in reach; never clone an order form. */
(() => {
  'use strict';
  if (window.NiralaProductPurchaseBar) { window.NiralaProductPurchaseBar.init(); return; }
  const instances = new Map();
  const mobile = window.matchMedia('(max-width: 800px)');
  let frame = 0;
  let started = false;

  function initializeSection(section) {
    if (instances.has(section)) return;
    const bar = section.querySelector('[data-product-purchase-bar]');
    const inline = section.querySelector('[data-product-purchase-inline]');
    const quantity = section.querySelector('[data-product-quantity-block]');
    const buy = section.querySelector('[data-product-buy-block]');
    if (!bar || !buy?.querySelector('[data-add-to-cart]')) return;
    const moves = [
      [quantity, bar.querySelector('[data-product-bar-quantity]'), inline?.querySelector('[data-product-inline-quantity]')],
      [buy, bar.querySelector('[data-product-bar-buy]'), inline?.querySelector('[data-product-inline-buy]')]
    ].filter(([node, host]) => node && host).map(([node, host, inlineHost]) => {
      const marker = document.createComment('Product control original position');
      node.before(marker);
      return { node, host, inlineHost, marker };
    });
    const choose = bar.querySelector('[data-product-bar-choose]');
    choose?.addEventListener('click', () => {
      const missing = section.querySelector('[data-product-option-group][data-confirmed="false"]');
      if (!missing) return;
      missing.open = true;
      missing.querySelector('summary')?.focus({ preventScroll: true });
      missing.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
    });
    const instance = { section, bar, inline, choose, moves, placement: 'original', observer: null };
    if (typeof ResizeObserver === 'function') {
      instance.observer = new ResizeObserver(schedule);
      instance.observer.observe(bar);
    }
    instances.set(section, instance);
  }

  function sync() {
    frame = 0;
    let visibleHeight = 0;
    const modalOpen = Boolean(document.querySelector('dialog[open]'));
    for (const [section, instance] of instances) {
      if (!section.isConnected) { instance.observer?.disconnect(); instances.delete(section); continue; }
      const { bar, inline, moves, choose } = instance;
      const enabled = mobile.matches ? section.dataset.purchaseBarMobile !== 'false' : section.dataset.purchaseBarDesktop !== 'false';
      const placement = enabled ? 'bar' : (!mobile.matches && inline ? 'inline' : 'original');
      if (placement !== instance.placement) {
        moves.forEach(({ node, host, inlineHost, marker }) => {
          if (placement === 'bar') host.appendChild(node);
          else if (placement === 'inline' && inlineHost) inlineHost.appendChild(node);
          else marker.after(node);
        });
        const chooseHost = placement === 'inline' ? inline.querySelector('[data-product-inline-buy]') : bar.querySelector('[data-product-bar-buy]');
        if (choose && chooseHost) chooseHost.prepend(choose);
        instance.placement = placement;
      }
      const incomplete = section.dataset.optionsReady === 'false';
      if (bar.dataset.optionsIncomplete !== String(incomplete)) bar.dataset.optionsIncomplete = String(incomplete);
      if (inline && inline.dataset.optionsIncomplete !== String(incomplete)) inline.dataset.optionsIncomplete = String(incomplete);
      if (inline && inline.hidden !== (placement !== 'inline')) inline.hidden = placement !== 'inline';
      if (choose && choose.hidden !== !incomplete) choose.hidden = !incomplete;
      const visible = enabled && !modalOpen;
      if (bar.hidden !== !visible) bar.hidden = !visible;
      if (visible) visibleHeight = Math.max(visibleHeight, Math.ceil(bar.getBoundingClientRect().height) || 96);
    }
    const wasActive = document.body.classList.contains('np-has-product-purchase-bar');
    const before = document.documentElement.style.getPropertyValue('--np-product-purchase-height');
    const after = visibleHeight ? `${visibleHeight}px` : '';
    document.body.classList.toggle('np-has-product-purchase-bar', visibleHeight > 0);
    if (before !== after) {
      if (after) document.documentElement.style.setProperty('--np-product-purchase-height', after);
      else document.documentElement.style.removeProperty('--np-product-purchase-height');
    }
    // The existing cart bar includes its bottom offset in the shared height.
    if (before !== after || wasActive !== (visibleHeight > 0)) window.NiralaStickyCart?.init?.();
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(sync);
  }

  function init() {
    if (!document.body) return;
    document.querySelectorAll('[data-product-section]').forEach(initializeSection);
    if (!started) {
      started = true;
      document.addEventListener('nirala:product-updated', schedule);
      document.addEventListener('nirala:addons-changed', schedule);
      document.addEventListener('shopify:section:load', init);
      document.addEventListener('shopify:section:unload', schedule);
      document.addEventListener('close', schedule, true);
      document.addEventListener('cancel', schedule, true);
      window.addEventListener('resize', schedule, { passive: true });
      window.addEventListener('pageshow', schedule);
      if (mobile.addEventListener) mobile.addEventListener('change', schedule);
      else mobile.addListener?.(schedule);
      if (typeof MutationObserver === 'function') {
        const observer = new MutationObserver(schedule);
        observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'data-purchase-bar-mobile', 'data-purchase-bar-desktop', 'data-options-ready'] });
      }
    }
    sync();
  }

  window.NiralaProductPurchaseBar = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
